import { Environment } from './environment';

interface AppConfig {
  [Environment.local]: IConfig;
  [Environment.preprod]: IConfig;
  [Environment.prod]: IConfig;
}

export interface SdkFeatureFlags {
  enableGrubApiCore: boolean;
  enableCookieAuthentication: boolean;
}

export interface IConfig {
  jjApiUrl: string;
  grubhubClientId: string;
  seamlessClientId: string;
  selfserviceFeedbackLink: string;
  contentful: {
    cdnUrl: string;
    spaceId: string;
    authToken: string;
    footerEntryId: string;
  };
  site: {
    standardTitle: string;
    enterpriseTitle: string;
    description: string;
    grubhubFavicon: string;
    seamlessFavicon: string;
  };
  selfServiceTealiumSrc: string;
  enterpriseGrubhubTealiumSrc: string;
  enterpriseSeamlessTealiumSrc: string;
  assetsURL: string;
  csvGuidelinesURL: string;
  enterpriseCsvGuidelinesURL: string;
  faqURL: string;
  datadog: {
    clientToken: string;
    applicationId: string;
    env: string;
  };
  manageExemptionCertificatesPortalUrl: string;
  grubhubOriginUrl: string;
  seamlessOriginUrl: string;
  customerServiceNumber: string;
  grubhubLogo: string;
  grubhubCorporateLogo: string;
  grubhubCorporateLogoWhite: string;
  seamlessLogo: string;
  preOrderExtension: number;
  ccIframeUrl: string;
  pxAppUrl: string;
  sdkFeatures: {
    grubhub: SdkFeatureFlags;
    seamless: SdkFeatureFlags;
  };
  devcycleSdkKey?: string;
  luzmo: {
    apiHost: string;
    appServer: string;
  };
}

const APP_CONFIG: AppConfig = {
  [Environment.local]: {
    jjApiUrl: 'https://api-order-taking-pp.grubhub.com',
    grubhubClientId:
      'tu7P94aGXt99gk6s3e8ffVeRFDFXsWAKKiAcFeCYuQiuf7CE3xNqiAQbgY8axThN',
    seamlessClientId:
      'rDsQ74nhfDjpsk7Jbq99WWL473pA2aEGX3aBJr4U9QK3JdpCVW8qFK2Zd5DhDCVG',
    selfserviceFeedbackLink:
      'https://www.surveygizmo.com/s3/6075025/selfservefeedback',
    contentful: {
      cdnUrl: 'https://preview.contentful.com',
      spaceId: 'yhm0akg1t95o',
      authToken:
        '989868351c081e1b7c4a3776246e2bfec1f6959b2cc8717aea85de9615410f44',
      footerEntryId: '1vPlr9s5N9EVhp4w7aA7w3',
    },
    site: {
      standardTitle: 'Grubhub | Self-Service Account',
      enterpriseTitle: 'Grubhub | Enterprise Account',
      description: '',
      grubhubFavicon:
        'https://media-cdn.grubhub.com/grubhub-assets/image/upload/v1746714821/wonderful/grubhub/GH_Favicon_Rebrand_WhiteOrangeBackground_RGB.svg',
      seamlessFavicon:
        'https://media-cdn.grubhub.com/grubhub-assets/image/upload/v1739825381/wonderful/seamless/favicon_red_bg_svg.svg',
    },
    selfServiceTealiumSrc:
      'https://tags.tiqcdn.com/utag/grubhubseamless/grubhub-self-service-corp-admin/dev/utag.js',
    enterpriseGrubhubTealiumSrc:
      'https://tags.tiqcdn.com/utag/grubhubseamless/grubhub-corp-admin/dev/utag.js',
    enterpriseSeamlessTealiumSrc:
      'https://tags.tiqcdn.com/utag/grubhubseamless/seamless-corp-admin/dev/utag.js',
    assetsURL: 'https://assets-corpselfservice-pp.grubhub.com',
    csvGuidelinesURL:
      'https://business.grubhub.com/learning-center/enterprise-accounts/employees-groups/uploading-employees-in-bulk/',
    enterpriseCsvGuidelinesURL:
      'https://corporate.grubhub.com/resource/admin-portal/uploading-employees-in-bulk/',
    faqURL: 'https://pp.grubhub.com/corporate/get-started/faq',
    datadog: {
      clientToken: 'pubb07c0fabe778fc517d6a7c13f6fe9346',
      applicationId: '30f920c2-0fbc-4f71-aa7f-4051d5691d2b',
      env: 'local',
    },
    manageExemptionCertificatesPortalUrl:
      'https://sbx.certexpress.com/?c=6865494a4635777a7250484474704e3545332b53:565150d6e8602b753d62a464e9124d46',
    grubhubOriginUrl: 'localhost:4001',
    seamlessOriginUrl: 'localhost:4002',
    customerServiceNumber: '844-478-2249 option 3',
    grubhubLogo:
      'https://media-cdn.grubhub.com/grubhub-assets/image/upload/v1744684421/wonderful/grubhub/GH_Logotype_Rebrand_Orange_RGB.svg',
    grubhubCorporateLogo:
      'https://media-cdn.grubhub.com/grubhub-assets/image/upload/v1750323943/corp-management-ui/lalk9wvyaghyhlxof677.png',
    grubhubCorporateLogoWhite:
      'https://media-cdn.grubhub.com/grubhub-assets/image/upload/v1750324466/corp-management-ui/alyp0pwgn80ilfwlovco.png',
    seamlessLogo:
      'https://media-cdn.grubhub.com/grubhub-assets/wonderful/seamless/Seamless-Standard-Logo-Red-NonRegistered_svg.svg',
    preOrderExtension: 30,
    ccIframeUrl: 'https://cc-pp.grubhub.com/ghs-payments.js',
    pxAppUrl: 'https://sensor-pp.grubhub.com/uRyvZ3Vg/init.js',
    sdkFeatures: {
      grubhub: {
        enableGrubApiCore: false,
        enableCookieAuthentication: false,
      },
      seamless: {
        enableGrubApiCore: false,
        enableCookieAuthentication: false,
      },
    },
    devcycleSdkKey: 'dvc_client_e25873e1_87c6_4055_9277_3e1b435f9db3_ab7d896',
    luzmo: {
      apiHost: 'https://api.us.luzmo.com',
      appServer: 'https://app.us.luzmo.com',
    },
  },
  [Environment.preprod]: {
    jjApiUrl: 'https://api-order-taking-pp.grubhub.com',
    grubhubClientId: 'beta_UmWlpstzQSFmocLy3h1UieYcVST',
    seamlessClientId: 'beta_seamless_ayNyuFxxVQYefSAhFYCryvXBPQc',
    selfserviceFeedbackLink:
      'https://www.surveygizmo.com/s3/6075025/selfservefeedback',
    contentful: {
      cdnUrl: 'https://preview.contentful.com',
      spaceId: 'yhm0akg1t95o',
      authToken:
        '989868351c081e1b7c4a3776246e2bfec1f6959b2cc8717aea85de9615410f44',
      footerEntryId: '1vPlr9s5N9EVhp4w7aA7w3',
    },
    site: {
      standardTitle: 'Grubhub | Self-Service Account',
      enterpriseTitle: 'Grubhub | Enterprise Account',
      description: '',
      grubhubFavicon:
        'https://media-cdn.grubhub.com/grubhub-assets/image/upload/v1746714821/wonderful/grubhub/GH_Favicon_Rebrand_WhiteOrangeBackground_RGB.svg',
      seamlessFavicon:
        'https://media-cdn.grubhub.com/grubhub-assets/image/upload/v1739825381/wonderful/seamless/favicon_red_bg_svg.svg',
    },
    selfServiceTealiumSrc:
      'https://tags.tiqcdn.com/utag/grubhubseamless/grubhub-self-service-corp-admin/qa/utag.js',
    enterpriseGrubhubTealiumSrc:
      'https://tags.tiqcdn.com/utag/grubhubseamless/grubhub-corp-admin/qa/utag.js',
    enterpriseSeamlessTealiumSrc:
      'https://tags.tiqcdn.com/utag/grubhubseamless/seamless-corp-admin/qa/utag.js',
    assetsURL: 'https://assets-corpselfservice-pp.grubhub.com',
    csvGuidelinesURL:
      'https://business.grubhub.com/learning-center/enterprise-accounts/employees-groups/uploading-employees-in-bulk/',
    enterpriseCsvGuidelinesURL:
      'https://corporate.grubhub.com/resource/admin-portal/uploading-employees-in-bulk/',
    faqURL: 'https://pp.grubhub.com/corporate/get-started/faq',
    datadog: {
      clientToken: 'pubb07c0fabe778fc517d6a7c13f6fe9346',
      applicationId: '30f920c2-0fbc-4f71-aa7f-4051d5691d2b',
      env: 'preprod',
    },
    manageExemptionCertificatesPortalUrl:
      'https://sbx.certexpress.com/?c=6865494a4635777a7250484474704e3545332b53:565150d6e8602b753d62a464e9124d46',
    grubhubOriginUrl: 'pp.grubhub.com',
    seamlessOriginUrl: 'pp.seamless.com',
    customerServiceNumber: '844-478-2249 option 3',
    grubhubLogo:
      'https://media-cdn.grubhub.com/grubhub-assets/image/upload/v1744684421/wonderful/grubhub/GH_Logotype_Rebrand_Orange_RGB.svg',
    grubhubCorporateLogo:
      'https://media-cdn.grubhub.com/grubhub-assets/image/upload/v1750323943/corp-management-ui/lalk9wvyaghyhlxof677.png',
    grubhubCorporateLogoWhite:
      'https://media-cdn.grubhub.com/grubhub-assets/image/upload/v1750324466/corp-management-ui/alyp0pwgn80ilfwlovco.png',
    seamlessLogo:
      'https://media-cdn.grubhub.com/grubhub-assets/wonderful/seamless/Seamless-Standard-Logo-Red-NonRegistered_svg.svg',
    preOrderExtension: 30,
    ccIframeUrl: 'https://cc-pp.grubhub.com/ghs-payments.js',
    pxAppUrl: 'https://sensor-pp.grubhub.com/uRyvZ3Vg/init.js',
    sdkFeatures: {
      grubhub: {
        enableGrubApiCore: true,
        enableCookieAuthentication: true,
      },
      seamless: {
        enableGrubApiCore: false,
        enableCookieAuthentication: false,
      },
    },
    devcycleSdkKey: 'dvc_client_e25873e1_87c6_4055_9277_3e1b435f9db3_ab7d896',
    luzmo: {
      apiHost: 'https://api.us.luzmo.com',
      appServer: 'https://app.us.luzmo.com',
    },
  },
  [Environment.prod]: {
    jjApiUrl: 'https://api-gtm.grubhub.com',
    grubhubClientId: 'beta_UmWlpstzQSFmocLy3h1UieYcVST',
    seamlessClientId: 'beta_seamless_ayNyuFxxVQYefSAhFYCryvXBPQc',
    selfserviceFeedbackLink:
      'https://www.surveygizmo.com/s3/6075025/selfservefeedback',
    contentful: {
      cdnUrl: 'https://cdn.contentful.com',
      spaceId: 'yhm0akg1t95o',
      authToken:
        '7e613e401c036ef5bb8210010979ce8c3b73827f1269e42af34556063318f36c',
      footerEntryId: '1vPlr9s5N9EVhp4w7aA7w3',
    },
    site: {
      standardTitle: 'Grubhub | Self-Service Account',
      enterpriseTitle: 'Grubhub | Enterprise Account',
      description: '',
      grubhubFavicon:
        'https://media-cdn.grubhub.com/grubhub-assets/image/upload/v1746714821/wonderful/grubhub/GH_Favicon_Rebrand_WhiteOrangeBackground_RGB.svg',
      seamlessFavicon:
        'https://media-cdn.grubhub.com/grubhub-assets/image/upload/v1739825381/wonderful/seamless/favicon_red_bg_svg.svg',
    },
    selfServiceTealiumSrc:
      'https://tags.tiqcdn.com/utag/grubhubseamless/grubhub-self-service-corp-admin/prod/utag.js',
    enterpriseGrubhubTealiumSrc:
      'https://tags.tiqcdn.com/utag/grubhubseamless/grubhub-corp-admin/prod/utag.js',
    enterpriseSeamlessTealiumSrc:
      'https://tags.tiqcdn.com/utag/grubhubseamless/seamless-corp-admin/prod/utag.js',
    assetsURL: 'https://assets-corpselfservice.grubhub.com',
    csvGuidelinesURL:
      'https://business.grubhub.com/learning-center/enterprise-accounts/employees-groups/uploading-employees-in-bulk/',
    enterpriseCsvGuidelinesURL:
      'https://corporate.grubhub.com/resource/admin-portal/uploading-employees-in-bulk/',
    faqURL: 'https://www.grubhub.com/corporate/get-started/faq',
    datadog: {
      clientToken: 'pubb07c0fabe778fc517d6a7c13f6fe9346',
      applicationId: '30f920c2-0fbc-4f71-aa7f-4051d5691d2b',
      env: 'prod',
    },
    manageExemptionCertificatesPortalUrl:
      'https://app.certexpress.com/?c=31423869614c2f334c3948346b71774277526a78:6f3c9b49731586e83a2384e7073735e3',
    grubhubOriginUrl: 'www.grubhub.com',
    seamlessOriginUrl: 'www.seamless.com',
    customerServiceNumber: '844-478-2249 option 3',
    grubhubLogo:
      'https://media-cdn.grubhub.com/grubhub-assets/image/upload/v1744684421/wonderful/grubhub/GH_Logotype_Rebrand_Orange_RGB.svg',
    grubhubCorporateLogo:
      'https://media-cdn.grubhub.com/grubhub-assets/image/upload/v1750323943/corp-management-ui/lalk9wvyaghyhlxof677.png',
    grubhubCorporateLogoWhite:
      'https://media-cdn.grubhub.com/grubhub-assets/image/upload/v1750324466/corp-management-ui/alyp0pwgn80ilfwlovco.png',
    seamlessLogo:
      'https://media-cdn.grubhub.com/grubhub-assets/wonderful/seamless/Seamless-Standard-Logo-Red-NonRegistered_svg.svg',
    preOrderExtension: 30,
    ccIframeUrl: 'https://cc.grubhub.com/ghs-payments.js',
    pxAppUrl: 'https://sensor.grubhub.com/O97ybH4J/init.js',
    sdkFeatures: {
      grubhub: {
        enableGrubApiCore: true,
        enableCookieAuthentication: true,
      },
      seamless: {
        enableGrubApiCore: false,
        enableCookieAuthentication: false,
      },
    },
    devcycleSdkKey: 'dvc_client_70cb6faf_1ab9_4eb2_be0e_98ecc29baf63_2e46197',
    luzmo: {
      apiHost: 'https://api.us.luzmo.com',
      appServer: 'https://app.us.luzmo.com',
    },
  },
};

export function getConfig(): IConfig {
  return APP_CONFIG[process.env.GH_ENV as Environment];
}
